import { useState } from "react";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";

const AccordionItem = ({
  title,
  children,
  className,
  headerClassName,
  contentClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  return (
    <div className={`border border-slate-200 rounded-lg ${className}`}>
      {/* Accordion Header */}
      <button
        onClick={toggleAccordion}
        className={`w-full flex justify-between items-center p-5 text-slate-800 ${headerClassName}`}
      >
        <span>{title}</span>
        <span
          className={`text-slate-800 transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          {isOpen ? (
            // Minus Icon
            <CiCircleMinus size={25} className={headerClassName} />
          ) : (
            // minus
            // Plus Icon
            <CiCirclePlus size={25} className={headerClassName} />
          )}
        </span>
      </button>

      {/* Accordion Content */}
      <div
        className={`overflow-hidden transition-all duration-400 ease-in-out rounded-lg bg-[#E9EAF8] ${
          isOpen ? "min-h-fit" : "max-h-0"
        } ${contentClassName}`}
        // style={{ maxHeight: isOpen ? "1000px" : "0" }}
      >
        {children}
      </div>
    </div>
  );
};

export default AccordionItem;
